<template>
  <div class="support-cols">
    <div class="donation support-col">
      <div class="title">Make a Donation:</div>
      <a href="https://www.paypal.me/ldlibrarysupply/50" class="triangle" target="_blank">$50</a><br/>
      <a href="https://www.paypal.me/ldlibrarysupply/100" class="triangle" target="_blank">$100</a><br/>
      <a href="https://www.paypal.me/ldlibrarysupply/500" class="triangle" target="_blank">$500</a><br/>
      <a href="https://www.paypal.me/ldlibrarysupply" class="triangle" target="_blank">Other amount</a><br/>
    </div>
    <div class="tshirt support-col">
      <div class="title">Buy an edition:</div>
      <a href="https://www.paypal.me/ldlibrarysupply/50" class="triangle">$50</a><br/><br/>
      Sign up for mailing list<br/>
      <a href="https://signup.ymlp.com/xghwhuhmgmgh" class="link" target="_blank">Email</a>
    </div>
    <div class="credit support-col">
      Thanks to: Jacob for design, Michael Delaney and Fredrik Nilson Studio for photography, Bryn Roberts for styling, and Jamie Connor for programming.
    </div>
    <Lightbox id="mylightbox"
              ref="lightbox"
              :images="images"
              :timeoutDuration="10000"
    ></Lightbox>
  </div>
</template>

<script>
  import Lightbox from 'vue-my-photos'
  export default {
    components: {
      Lightbox
    },
    name: 'StatementPage',
    data() {
      return {
        images : [{'name':'/images/shirt.png'}]
      }
    },
    mounted() {
    },
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/SupportPage.vue